export default function ({ store, redirect }) {
  // If the user is not authenticated
  if (store.state.createOccupation.occupation.id === 0) {
    return redirect('/empresas/ocupaciones-requeridas')
  }
}
